import React from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import BodyWrap from "../../utils/BodyWrap";
import GeneralLoader from "../../GeneralLoader";
import ContentDiv from "../../utils/ContentDiv";
import CreateForm from "./CreateForm";
import CreateSuccess from "./CreateSuccess";

// State
import { getTranslations } from "../../../store/actions/translations";

class CreateAccount extends React.PureComponent {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["reviewer_registration_form", "form_elements"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			CreateAccount.initialAction(null, this.props);
		}
	}

	render() {
		const { accountCreateSuccess, translationsLoading, translations } = this.props;

		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title;
		}
		if (!!translations.pages[getTranslations]) {
			if (title !== "") title += " | ";
			title += translations.pages[getTranslations].title;
		}

		// Show meta tags
		// const helmet = (
		// 	<Helmet>
		// 		<title>{title}</title>
		// 	</Helmet>
		// );

		return (
			<BodyWrap>
				{/* {helmet} */}

				<main className="content-bottom-margin">
					<div className="content-header centered">
						{translationsLoading ? (
							<GeneralLoader />
						) : !!translations.pages[this.props.translationKey] ? (
							<ContentDiv className="page-text">
								{translations.pages[this.props.translationKey].content}
							</ContentDiv>
						) : null}
					</div>
					{translationsLoading ? (
						<GeneralLoader />
					) : accountCreateSuccess ? (
						<CreateSuccess />
					) : (
								<CreateForm />
							)}
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		accountCreateSuccess: state.user.accountCreateSuccess
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations }
)(CreateAccount);



// WEBPACK FOOTER //
// ./src/components/reviewer/create/CreateAccount.js